// docs/78 BW5, docs/83 PO10 — one ping, the same on the World chart and the encounter board: rings
// in the pinger's colour, a square pin bobbing over the spot ("!" for danger), and who pinged it
// under them. The caller places it (`style`: left/top or CSS variables) and decides how long it lives.
import type { CSSProperties } from 'react';
import { PING_DANGER, PING_MS } from '../../core/pings';
import './ping.css';

export function PingMark({ kind, colour, who, className = '', style, testId, owner }: {
  kind: number; colour: string; who: string; className?: string; style?: CSSProperties; testId?: string; owner?: string;
}) {
  return (
    <div className={`fk-ping ${kind === PING_DANGER ? 'fk-ping--danger' : ''} ${className}`}
      style={{ ['--fk-seat' as string]: colour, ['--ping-ms' as string]: `${PING_MS}ms`, ...style } as CSSProperties}
      data-testid={testId} data-kind={kind} data-owner={owner}>
      <i className="fk-ping__ring" aria-hidden="true" />
      <i className="fk-ping__ring fk-ping__ring--echo" aria-hidden="true" />
      <i className="fk-ping__pin" aria-hidden="true">{kind === PING_DANGER ? '!' : ''}</i>
      <span className="fk-ping__who">{who}</span>
    </div>
  );
}
